//JavaScript Document
// import { cryptoSHA256 } from "crypto-js";
// import encHex from "crypto-js/enc-hex";
import { default as axios } from "./axios";
export { default as axios } from "./axios";

export const WORKSPACEIDKEY = "bdp-user-workspace-id";
export const WORKSPACENAMEKEY = "bdp-user-workspace-name";

export const {
  SYSTEM_MANAGER_REST,
  ROOT_SERVER,
  EXCHANGIS_WEB,
  NODE_ENV,
  PUBLIC_PATH,
  TRACKURL,
  DINKY_WEB,
  DINKY_SERVER,
  unicorEyeAppKey,
} = ENV_CONFIG;

export { default as querystring } from "./querystring";

//export const ENV_URL = (ENV_CONFIG.NODE_ENV == 'PROD') ? SYSTEM_MANAGER_REST : '';
export const ENV_URL = "";

export const apiUrl = {
  // 租户列表 get
  workspaceList: ENV_URL + `/api/rest_j/v1/dss/workspaces`,
  // 数据申请列表接口
  dataApplyList: ENV_URL + `/api/rest_j/v1/acl/apply/permission/resource`,
  // 租户申请列表接口
  userApplyList: ENV_URL + `/api/rest_j/v1/acl/apply/permission/workspace`,
  // 作业申请列表接口
  jobApplyList: ENV_URL + `/api/rest_j/v1/acl/flow`,
  // 数据审批列表接口
  dataApproveList: ENV_URL + `/api/rest_j/v1/acl/approve/permission/resource`,
  // 租户审批列表接口
  userApproveList: ENV_URL + `/api/rest_j/v1/acl/approve/permission/workspace`,
  // 作业审批列表接口
  jobApproveList: ENV_URL + `/api/rest_j/v1/acl/flow`,
  // 用户已有的租户权限
  hasPermissionWorkspace:
    ENV_URL + `/api/rest_j/v1/acl/user/permission/workspace`,
  // 租户申请操作接口
  applyWorkspace: ENV_URL + `/api/rest_j/v1/acl/apply/permission/workspace`,
  // 数据审批操作接口
  dataApproveOp: ENV_URL + `/api/rest_j/v1/acl/approve/permission/resource`,
  // 租户审批操作接口
  workspaceApproveOp:
    ENV_URL + `/api/rest_j/v1/acl/approve/permission/workspace`,
  //作业审批操作接口
  jobApproveOp: ENV_URL + `/api/rest_j/v1/acl/approve/flow`,
  // 获取资源基本信息
  getResBaseInfo: ENV_URL + `/api/rest_j/v1/metadata/v1/getResBaseInfo`,
  // 获取资源字段信息
  getResCols: ENV_URL + `/api/rest_j/v1/metadata/v1/getResCols`,
  // 获取部门
  getDepartments: ENV_URL + `/api/rest_j/v1/dss/workspaces/departments`,
  // 校验租户存在
  existsName: ENV_URL + `/api/rest_j/v1/dss/workspaces/exists`,
  // 保存租户 post
  saveWorkspace: ENV_URL + `/api/rest_j/v1/dss/workspaces`,
  //用户权限接口 usercode转username
  transferUsercode2Name: SYSTEM_MANAGER_REST + `/user/getUserList`,
};
const unicorEyeAppId = "MB-ISPQLY-0000";
let cryptoSHA256 = require("crypto-js/sha256"),
  encHex = require("crypto-js/enc-hex");

let getSign = (timestamp, body = "", url, appId, appKey) => {
  body = body.replace(/\s/g, "");
  body = body.replace(/\t/g, "");
  body = body.replace(/\r/g, "");
  body = body.replace(/\n/g, "");

  url = url.substring(url.indexOf("/", 8));
  if (url.indexOf("?") != -1) {
    url = url.substring(0, url.indexOf("?"));
  }
  let sign = encHex.stringify(
    cryptoSHA256(url + body + appId + appKey + timestamp)
  );
  return sign;
};

export let requestWithSign = ({
  method,
  url,
  data,
  appId = unicorEyeAppId,
  appKey = unicorEyeAppKey,
  token,
  ticket=""
}) => {
  let timestamp = new Date().getTime().toString();
  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
    appId,
    timestamp,
    sign: getSign(timestamp, JSON.stringify(data), url, appId, appKey),
    "Access-User-Token": token,
  };
  if(ticket){
    headers["ticket"] = ticket;
  }
  let options = {
    method,
    url,
    headers,
    data,
    transformRequest: [
      function(data, headers) {
        return JSON.stringify(data);
      },
    ],
  };
  return axios(options);
};
//keys可包含第一级字段，也可以子对象的字段，或子array里的字段
// export let transformUserIdToName = async (list, keys) => {
//   let keyArr = keys.split(",");
//   let userIds = new Set();
//   list.forEach((item) => {
//     keyArr.forEach((key) => {
//       if (key.indexOf(".") > -1) {
//         let [subItem, subItemKey] = key.split(".");
//         //子字段是array
//         if (Array.isArray(item[subItem])) {
//           item[subItem].forEach((ssItem) => {
//             if (
//               ssItem[subItemKey] &&
//               ssItem[subItemKey] !== "hadoop" &&
//               ssItem[subItemKey] !== "root"
//             ) {
//               userIds.add(ssItem[subItemKey]);
//             }
//           });
//         } else if (item[subItem]) {
//           //子字段是对象
//           if (
//             item[subItem][subItemKey] !== "hadoop" &&
//             item[subItem][subItemKey] !== "root"
//           ) {
//             userIds.add(item[subItem][subItemKey]);
//           }
//         }
//       } else {
//         if (item[key] && item[key] !== "hadoop" && item[key] !== "root") {
//           userIds.add(item[key]);
//         }
//       }
//     });
//   });
//   if (userIds.size == 0) {
//     return list;
//   }
//   let resp = await axios({
//     url: `${SYSTEM_MANAGER_REST}/user/getUserList`,
//     data: { userCodeList: [...userIds] },
//     method: "post",
//     headers: { "Content-Type": "application/json; charset=UTF-8" },
//     transformRequest: [
//       function(data, headers) {
//         return JSON.stringify(data);
//       },
//     ],
//   });
//   let userNames = {};
//   resp.data.forEach((item) => (userNames[item.usercode] = item.fullname));
//   list.forEach((item) => {
//     keyArr.forEach((key) => {
//       if (key.indexOf(".") > -1) {
//         let [subItem, subItemKey] = key.split(".");
//         //子字段是array
//         if (Array.isArray(item[subItem])) {
//           item[subItem].forEach((ssItem) => {
//             if (userNames[ssItem[subItemKey]] !== undefined) {
//               ssItem[subItemKey] = `${userNames[ssItem[subItemKey]]}(${
//                 ssItem[subItemKey]
//               })`;
//             }
//           });
//         } else if (item[subItem]) {
//           //子字段是对象
//           if (userNames[item[subItem][subItemKey]] !== undefined) {
//             item[subItem][
//               subItemKey
//             ] = `${userNamesitem[subItem][subItemKey]}(${item[subItem][subItemKey]})`;
//           }
//         }
//       } else {
//         if (userNames[item[key]] !== undefined) {
//           item[key] = `${userNames[item[key]]}(${item[key]})`;
//         }
//       }
//     });
//   });
//   return list;
// };

export let transformUserIdToName = async (list, keys, needEmail) => {
  let keyArr = keys.split(",");
  let userIds = new Set();
  list.forEach((item) => {
    keyArr.forEach((key) => {
      if (key.indexOf(".") > -1) {
        let [subItem, subItemKey] = key.split(".");
        //子字段是array
        if (Array.isArray(item[subItem])) {
          item[subItem].forEach((ssItem) => {
            if (
              ssItem[subItemKey] &&
              ssItem[subItemKey] !== "hadoop" &&
              ssItem[subItemKey] !== "root"
            ) {
              userIds.add(ssItem[subItemKey]);
            }
          });
        } else if (item[subItem]) {
          //子字段是对象
          if (
            item[subItem][subItemKey] !== "hadoop" &&
            item[subItem][subItemKey] !== "root"
          ) {
            userIds.add(item[subItem][subItemKey]);
          }
        }
      } else {
        if (item[key] && item[key] !== "hadoop" && item[key] !== "root") {
          if(item[key] && item[key].includes(",")){//多个userId
            let list = item[key].split(",");
            list.forEach(user=>{
              userIds.add(user);
            })
          }else{
            userIds.add(item[key]);
          }
         
        }
      }
    });
  });
  if (userIds.size == 0) {
    return list;
  }
  let resp = await axios({
    url: `${SYSTEM_MANAGER_REST}/user/getUserList`,
    data: { userCodeList: [...userIds] },
    method: "post",
    headers: { "Content-Type": "application/json; charset=UTF-8" },
    transformRequest: [
      function(data, headers) {
        return JSON.stringify(data);
      },
    ],
  });
  let userNames = {}, userEmail = {}
  resp.data.forEach((item) =>{ 
    userNames[item.usercode] = item.fullname;
    userEmail[item.usercode] = item.notesemail;
  });
  list.forEach((item) => {
    keyArr.forEach((key) => {
      if (key.indexOf(".") > -1) {
        let [subItem, subItemKey] = key.split(".");
        //子字段是array
        if (Array.isArray(item[subItem])) {
          item[subItem].forEach((ssItem) => {
            if (userNames[ssItem[subItemKey]] !== undefined) {
              ssItem[subItemKey] = `${userNames[ssItem[subItemKey]]}(${
                ssItem[subItemKey]
              })`;
            }
          });
        } else if (item[subItem]) {
          //子字段是对象
          if (userNames[item[subItem][subItemKey]] !== undefined) {
            item[subItem][
              subItemKey
            ] = `${userNamesitem[subItem][subItemKey]}(${item[subItem][subItemKey]})`;
          }
        }
      } else if( item[key] ){
        if (!item[key].includes(",")&&userNames[item[key]] !== undefined) {
          if(needEmail){
            item["email"] = userEmail[item[key]]?userEmail[item[key]].toLowerCase():"";
          }
          item[key] = `${userNames[item[key]]}(${item[key]})`;
        }else if(item[key].includes(",")){
            let list = item[key].split(",");
            item[key] = "";
            list.forEach(user=>{
              if(userNames[user]!==undefined){
                item[key] += `${userNames[user]}(${user}),`;
              }
            });
            item[key] = item[key].substring(0,item[key].length-1);
        }
      }
    });
  });
  return list;
};
export const methodList = [
  "GET",
  "HEAD",
  "POST",
  "PUT",
  "PATCH",
  "DELETE",
  "OPTIONS",
  "TRACE",
];
export let  saveResByActionType =  (type,resId,userId)=>{
  axios({
    method: "POST",
    url: `/api/rest_j/v1/metadata/v1/saveResByActionType`,
    data: {
      userId,
      type,
      resId,
    },
  }).catch((err) => {
    console.log(err);
  });
};
